<div *ngIf="!circle" class="bg-gray-light animate-pulse rounded w-full" [ngClass]="heigthTailwind"></div>
<div *ngIf="circle" class="bg-gray-light animate-pulse rounded-full w-full" [ngClass]="heigthTailwind"></div>
